import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import ProjectCard from '../Explore/ProjectCard'
import StackGrid from "react-stack-grid";
import ProjectInfos from '../Explore/ProjectInfos'

import Create from '../Icons/Create.svg';
import Launch from '../Icons/Launch.svg';
import './Yourprojects.css'

class Yourprojects extends Component {

	setCurrentRoute(){
		this.props.actions.setCurrentRoute('Your projects');
	}

	componentDidMount() {
	    this.setCurrentRoute();
		this.props.actions.getWallet();
	    this.props.actions.getPersonnalProjects();
	}

	render() {
		const createItem = (item, index) => {
	    	return <div className="projectCard" key={item.project_id}>
	    			<ProjectInfos current_amount={item.current_amount} 
						target={item.target} 
						privacy={item.privacy}
						project_id={item.project_id}
						achieved_at={item.project_achieved_at}
						currentUser={this.props.currentUser} 
						creator_email={item.creator_email} 
						actions={this.props.actions}
						answerIsLoading={this.props.answerIsLoading}
						has_accepted_invite={item.has_accepted_invite} />
					<Link to={'/projects/'+item.project_id} key={item.project_id}>
						<ProjectCard 
							data={item} 
							id={item.project_id} 
							key={item.project_id} 
							currentUser={this.props.currentUser} 
							achieved_at={item.project_achieved_at}
							actions={this.props.actions} />
					</Link>
				</div>
	    }
		return (
			<div>
				<div className="container">
					<div className="myprojects-container">
						<div className="profile-bloc">
							<div className="avatar">
								{this.props.currentUser.avatar &&
									<img src={this.props.currentUser.avatar} alt="avatar" />
								}
							</div>
							<div className="name">{this.props.currentUser.name}</div>
							{this.props.currentUser.wallet >= 0 &&
								<div className="walletAmount">€{this.props.currentUser.wallet} left</div>
							}
						</div>
						{this.props.currentUserProjectInvitations.length > 0 &&
							<div className="cardsContainer">
								<div className="title">Requests to join a project</div>
								<StackGrid
							        columnWidth={250}
							        gutterHeight={20}
							        gutterWidth={20}
							      >
									{this.props.currentUserProjectInvitations.map(createItem)}
								</StackGrid>
							</div>
						}
						{!this.props.emptyPrivateProjects ?
							<div className="cardsContainer">
								<div className="title">My projects</div>
								<StackGrid
							        columnWidth={250}
							        gutterHeight={20}
							        gutterWidth={20}
							      >
								    <Link to='/create'>
										<div className="projectCard add">
											<div className="createIcon"><img src={Create} alt="Create your own project" title="Create your own project" /></div>
											<div className="createText">Add a project</div>
										</div>
									</Link>
									{this.props.currentUserProjects.map(createItem)}
								</StackGrid>
							</div>
						: <div className="cardsContainer empty">
								<div className="title">Create your first project!</div>
								<div className="default">
									<div className="illustration">
										<img src={Launch} alt="Create the first project" />
									</div>
									<Link to='/create'>
										<button className="button is-primary">Create a project</button>
									</Link>
								</div>
							</div>
						}
						{this.props.currentUserBackedProjects.length > 0 &&
							<div className="cardsContainer">
								<div className="title">My backings</div>
								<StackGrid
							        columnWidth={250}
							        gutterHeight={20}
							        gutterWidth={20}
							      >
									{this.props.currentUserBackedProjects.map(createItem)}
								</StackGrid>
							</div>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default Yourprojects;



// WEBPACK FOOTER //
// ./src/components/Yourprojects/Yourprojects.js